<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2 md6 offset-md3 lg4 offset-lg4 mt-3 class="box650">
      <v-flex xs12 class="text-xs-center" mt-5>
        <h1>{{$t('reset_password_text')}}</h1>
      </v-flex>
        <form @submit.prevent="sendEmail(email)">
          <v-layout column>
            <v-flex>
              <v-alert type="info" dismissible v-model="alert">
                {{ error }}
              </v-alert>
            </v-flex>
            <v-flex>
              <v-text-field
                autofocus
                name="email"
                :label="$t('email')"
                id="email"
                type="email"
                v-model="email"
                autocomplete="username email"
                required></v-text-field>
            </v-flex>
            <v-btn
              color="primary"
              type="submit"
              :disabled="isLoading || sent"
              :loading="isLoading">{{$t('Enviar')}}</v-btn>

            <!--
            <v-btn
              v-if="sent"
              color="primary"
              :to="{ name: 'Home' }"
              :disabled="isLoading"
              :loading="isLoading">{{$t('Volver al inicio')}}</v-btn>
            -->
          </v-layout>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { auth } from '@/config'
import router from '@/router'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      email: '',
      alert: false,
      isLoading: false,
      sent: false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.sent = false
      vm.email = vm.$store.getters.email || ''
      return true
    })
  },
  beforeRouteLeave (to, from, next) {
    this.sent = false
    this.alert = false
    this.$store.commit('setError', null)
    next()
  },
  methods: {
    async sendEmail (email) {
      try {
        await auth.sendPasswordResetEmail(email)
        this.$store.commit('setError', this.$t('Enviado'))
        this.sent = true
        setTimeout(() => {
          router.replace({ name: 'Home' })
        }, 500)
      }
      catch(e) {
        this.$store.commit('setError', this.$t('user-not-found'))
      }
    }
  },
  computed: {
    error () {
      return this.$store.state.error
    }
  },
  watch: {
    error (value) {
      if (value) {
        this.isLoading = false
        this.alert = true
      }
    },
    alert (value) {
      if (!value) {
        this.$store.commit('setError', null)
      }
    }
  }
}
</script>
<style>
  .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: white;
  }
</style>
